import { Subject } from 'rxjs';

// This is a plain TypeScript base class for use in Angular components/services.
export abstract class Destroyable {
  protected destroy$ = new Subject<void>();

  // Should be called from ngOnDestroy in subclasses
  protected cleanup() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
